import { useLangFile } from '../../context/LanguageContext';
import React, { memo } from 'react';
import { ArrowBack, FilterList } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { voidFunc } from '../../constants/PropTypeUtils';
import { AppBar, Button, Box, Typography, Toolbar, ButtonBase } from '@mui/material';
import Logo from '../UI-Elements/Logo';
import useBreakpoint from '../../hooks/useBreakpoint';
import Styles from './FieldStatisticsToolbar.module.less';

const FieldStatisticsToolbar = (props: FieldStatisticsToolbar.propTypes) => {
  const { onBackButtonClicked, onEditButtonClicked } = props;

  const LangFile = useLangFile();

  const breakpoint = useBreakpoint();
  const narrow = breakpoint === 'sm' || breakpoint === 'xs';

  return (
    <AppBar position="static" color="inherit" className={Styles.AppBar} elevation={0}>
      <Toolbar className={Styles.Toolbar} disableGutters>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: 1 / 3,
              display: 'flex',
              alignItems: 'center',
              pl: 2,
            }}
          >
            <Box className={Styles.ButtonWrapper}>
              <ButtonBase onClick={onBackButtonClicked}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    mr: 1.5,
                    justifyContent: 'center',
                  }}
                >
                  <ArrowBack />
                </Box>
                <Typography>{LangFile.PrescriptionLayerDialog.back}</Typography>
              </ButtonBase>
            </Box>
          </Box>
          <Box
            sx={{
              width: 1 / 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Logo variant={narrow ? 'short' : 'full'} size={24} />
          </Box>
          <Box
            sx={{
              width: 1 / 3,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              pr: 2,
            }}
          >
            <Box
              sx={{
                mr: 1,
              }}
            />
            <Button className={Styles.button} onClick={onEditButtonClicked} variant={'outlined'}>
              <Typography className={Styles.buttonText}>
                {LangFile.FieldStatistics.filterColumns}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  ml: 1,
                  justifyContent: 'center',
                }}
              >
                <FilterList style={{ height: 20 }} />
              </Box>
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

FieldStatisticsToolbar.propTypes = {
  onBackButtonClicked: PropTypes.func,
  onEditButtonClicked: PropTypes.func,
};

FieldStatisticsToolbar.defaultProps = {
  onBackButtonClicked: voidFunc,
  onEditButtonClicked: voidFunc,
};

export default memo(FieldStatisticsToolbar);
